import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  icon: PropTypes.node,
  iconClassName: PropTypes.string,
  children: PropTypes.node,
};

const CardElementPlaceholder = ({
  icon,
  iconClassName,
  children,
  className,
}) => {
  const classes = classNames({
    'card-element-placeholder': true,
    [className]: !!className,
  });

  const iconClasses = classNames({
    'card-element-placeholder-icon': true,
    [iconClassName]: !!iconClassName,
  });

  return (
    <div className={classes}>
      {icon && <span className={iconClasses}>{icon}</span>}
      {children && (
        <div className="card-element-placeholder-children">{children}</div>
      )}
    </div>
  );
};

CardElementPlaceholder.propTypes = propTypes;

export default CardElementPlaceholder;
